import { canUseDom } from "@plinknz/tah-website-elements";
import * as React from "react";

export const ServerSuspense = ({ children, ...props }: React.SuspenseProps) =>
    canUseDom() ? (
        <React.Suspense {...props}>{children}</React.Suspense>
    ) : (
        <></>
    );
